<template>
  <div
    id="confirmDiscardModal"
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="pricesModalTitle"
    aria-hidden="true"
    data-keyboard="false"
    data-backdrop="static">
    <div
      class="modal-dialog "
      role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ $t('message.leavepage') }}
          </h5>
        </div>
        <div class="modal-body">
          {{ $t('message.confirmunsavedchanges') }}
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            @click="onCancel">{{ $t('button.continueedit') }}</button>
          <button
            type="button"
            class="btn btn-web"
            @click="onConfirm">{{ $t('button.leave') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['show'],

  watch: {
    show () {
      if (this.show) {
        $('#confirmDiscardModal').modal('show')
      } else {
        $('#confirmDiscardModal').modal('hide')
      }
    },
  },

  mounted () {
    this.setModal('#confirmDiscardModal')
    if (this.show) {
      $('#confirmDiscardModal').modal('show')
    }
  },

  destroyed () {
    this.leavePage(this.$Progress)
  },

  methods: {
    onCancel () {
      this.$emit('onCancel')
    },
    onConfirm () {
      this.$emit('onConfirm')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseConfirmDiscardModal.vue